module.exports = __webpack_public_path__ + "media/img/vca/banner-main-9d62c88178a249c789f45faa479096e1.png";